import { editorAPI } from '../text-editor'
import { SendFieldIconButton } from '../icon-button'

export const SendMessageButton = ({
  onSend,
  children,
  disabled,
}: {
  onSend: () => any
  children: JSX.Element
  disabled: boolean
}) => (
  <SendFieldIconButton
    disabled={disabled}
    onClick={onSend}
    onMouseDown={() => {
      if (editorAPI.hasFocus) editorAPI.setKeepFocus(true)
    }}
  >
    {children}
  </SendFieldIconButton>
)
